/**
 * The two initials an `IdentityTile` carries for a person. Takes the first *code point* of each name,
 * never `charAt(0)`, which would cut an emoji or an astral character in half and render a replacement
 * glyph. An empty name contributes nothing rather than a placeholder.
 */
const initialsOf = (firstName: string, lastName: string): string => {
	const firstInitial = [...firstName.trim()][0] ?? '';
	const lastInitial = [...lastName.trim()][0] ?? '';

	return `${firstInitial}${lastInitial}`.toUpperCase();
};

export default initialsOf;
